export const switchWrapper = {
    '> div': {
        margin: 0,
        padding: 0,
    },
}
